/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type AiLanguage =
  | 'ar'
  | 'cs'
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'hi'
  | 'hr'
  | 'it'
  | 'lb'
  | 'nl'
  | 'po'
  | 'pt'
  | 'ro'
  | 'rs'
  | 'ru'
  | 'se'
  | 'sl'
  | 'sq'
  | 'tr'
  | 'ur';

/** Generic input for queries and mutations by id */
export type IdInput = {
  /** Non-empty id of an object or entity */
  id: string;
};

export type AiSettingsQueryVariables = Exact<{
  courseIdInput: Types.IdInput;
}>;


export type AiSettingsQuery = { aiSettings: { id: string, subject: string, age: number, language: Types.AiLanguage, curriculum: string | null, linkedCurriculum: { id: string } | null, linkedCurriculumContent: { id: string } | null } | null };


export const AiSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"aiSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseIdInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseIdInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseIdInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"curriculum"}},{"kind":"Field","name":{"kind":"Name","value":"linkedCurriculum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedCurriculumContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AiSettingsQuery, AiSettingsQueryVariables>;